var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.666,
    height: 27.6,
    viewBox: "0 0 30.666 27.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "camera-svgrepo-com",
    d: "M13.926,30.6H20.74c4.786,0,7.178,0,8.9-1.128a6.759,6.759,0,0,0,1.88-1.846c1.148-1.688,1.148-4.037,1.148-8.735s0-7.048-1.148-8.735a6.757,6.757,0,0,0-1.88-1.846,8.818,8.818,0,0,0-4.6-1.076,2.156,2.156,0,0,1-2.078-1.724A3.165,3.165,0,0,0,19.838,3h-5.01a3.165,3.165,0,0,0-3.117,2.509A2.156,2.156,0,0,1,9.633,7.233a8.817,8.817,0,0,0-4.6,1.076,6.754,6.754,0,0,0-1.88,1.846C2,11.843,2,14.192,2,18.891s0,7.048,1.148,8.735a6.756,6.756,0,0,0,1.88,1.846C6.748,30.6,9.14,30.6,13.926,30.6Zm3.407-17.982a6.274,6.274,0,1,0,6.389,6.273A6.332,6.332,0,0,0,17.333,12.618Zm0,2.509a3.764,3.764,0,1,0,3.833,3.764A3.8,3.8,0,0,0,17.333,15.127Zm7.241-1.255a1.266,1.266,0,0,1,1.278-1.255h1.7a1.255,1.255,0,1,1,0,2.509h-1.7A1.266,1.266,0,0,1,24.574,13.873Z",
    transform: "translate(-2 -3)",
    fill: "#3e93e8",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraLogo);
export default __webpack_public_path__ + "static/media/camera-logo.ba6649e03a078d1bdea639d8efb0982e.svg";
export { ForwardRef as ReactComponent };